export enum STATUS_TYPES {
	Completed,
	Pending,
	ReviewRequired
}
